module.exports = __webpack_public_path__ + "static/media/the-game-afl-2025.d013761d.png";